/**
 * Parses `demoId:stepNumber` keys used by Story Service integration.
 * Returns null for keys without a colon prefix (e.g. `fallback`, ``, `legacy` alone).
 */
export function storyStepDemoIdFromKey(stepKey: string): string | null {
  const idx = stepKey.indexOf(':');
  if (idx <= 0) return null;
  const id = stepKey.slice(0, idx).trim();
  return id.length > 0 ? id : null;
}
